import React from "react";
import { Grid, Button } from "..";
import { useRouter } from "next/router";
import clsx from "clsx";
import { createMemoClass } from "../create-memo-class";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DonationBanner = _ref => {
  var {
    button_text,
    button_url,
    button_color,
    background_color = "default",
    text_color,
    content
  } = _ref;
  var router = useRouter();
  var variant = process.env.NEXT_PUBLIC_VARIANT || "";
  var classes = useDonationBannerClass({
    background_color,
    text_color
  });
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    children: /*#__PURE__*/_jsxs(Grid, {
      layout: "2-1",
      gap: "4",
      children: [/*#__PURE__*/_jsx("div", {
        children: content ? /*#__PURE__*/_jsx("article", {
          className: "mt-2 m-0",
          children: content
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("p", {
            className: "mt-2 m-0",
            children: "Our work is only made possible by your generous support. Thank you."
          }), /*#__PURE__*/_jsx("strong", {
            children: "Donations over $2 are tax deductible"
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex items-center justify-center lg:justify-end",
        children: button_text ? /*#__PURE__*/_jsx(Button, {
          type: "button",
          color: button_color,
          size: "md",
          onClick: () => router.push({
            pathname: button_url != null && button_url.cached_url ? button_url.cached_url.replace(variant, "") : "/donate"
          }, undefined, {
            scroll: false
          }),
          children: button_text ? button_text : "Donate Now"
        }) : null
      })]
    })
  });
};
export var useDonationBannerClass = createMemoClass(props => {
  var backgroundColors = {
    default: "bg-grey-100/10",
    primary: "!bg-primary",
    secondary: "!bg-secondary",
    tertiary: "!bg-tertiary",
    neutral: "!bg-neutral",
    transparent: "!bg-transparent"
  };
  var textColors = {
    primary: "!text-primary",
    secondary: "!text-secondary",
    tertiary: "!text-tertiary",
    neutral: "!text-neutral",
    transparent: "!text-transparent"
  };
  var classes = clsx("rounded-container shadow-lg p-8 w-full", backgroundColors[props.background_color], props.text_color && textColors[props.text_color]);
  return classes;
});
//# sourceMappingURL=donation_banner.js.map